"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _Rating = _interopRequireDefault(require("@material-ui/lab/Rating"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Heading = _interopRequireDefault(require("../../../protons/typography/heading/Heading"));

var _Span = _interopRequireDefault(require("../../../protons/typography/span/Span"));

require("slick-carousel/slick/slick.scss");

require("slick-carousel/slick/slick-theme.scss");

var _AppTheme = _interopRequireDefault(require("../../../../AppTheme"));

var _PickerColor = _interopRequireDefault(require("../../../molecules/pickers/pickerColor/PickerColor"));

var _PickerSize = _interopRequireDefault(require("../../../molecules/pickers/pickerSize/PickerSize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _core.makeStyles)({
  carousel: {
    "& .slick-dots": {
      bottom: 0
    }
  }
});
var labels = {
  1: 'Useless',
  2: 'Poor',
  3: 'Ok',
  4: 'Good',
  5: 'Excellent'
};
var settings = {
  arrows: false,
  dots: true,
  infinite: false,
  speed: _AppTheme.default.transitions.duration.complex,
  slidesToShow: 1,
  slidesToScroll: 1
};

var CardProduct = function CardProduct(_ref) {
  var title = _ref.title,
      label = _ref.label,
      color = _ref.color,
      image = _ref.image,
      desc = _ref.desc,
      price = _ref.price,
      sizes = _ref.sizes,
      colors = _ref.colors,
      _ref$priceType = _ref.priceType,
      priceType = _ref$priceType === void 0 ? 'gl' : _ref$priceType,
      compare = _ref.compare,
      rating = _ref.rating,
      children = _ref.children,
      loading = _ref.loading;

  var _React$useState = _react.default.useState(2),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = _react.default.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedSize = _React$useState4[0],
      setSelectedSize = _React$useState4[1];

  var _React$useState5 = _react.default.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      selectedColor = _React$useState6[0],
      setSelectedColor = _React$useState6[1];

  var _React$useState7 = _react.default.useState(-1),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      hover = _React$useState8[0],
      setHover = _React$useState8[1];

  var _React$useState9 = _react.default.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      checked = _React$useState10[0],
      setChecked = _React$useState10[1];

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    elevation: 0,
    className: (0, _classnames.default)({
      'MuiCard-product': true,
      'MuiCard-outlined': true,
      'MuiCard-outlined-primary': color === 'primary',
      'MuiCard-outlined-secondary': color === 'secondary',
      'MuiCard-outlined-success': color === 'success',
      'MuiCard-outlined-orange': color === 'orange',
      'MuiCard-outlined-withLabel': label
    })
  }, loading ? /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    animation: "wave",
    height: 240
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    animation: "wave",
    height: 18,
    width: "60%"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    animation: "wave",
    height: 30,
    width: "80%"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    animation: "wave",
    height: 18
  })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label && /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: (0, _classnames.default)({
      'MuiCardContent-label': label,
      'MuiCardContent-label-primary': color === 'primary',
      'MuiCardContent-label-success': color === 'success',
      'MuiCardContent-label-secondary': color === 'secondary',
      'MuiCardContent-label-orange': color === 'orange'
    })
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: label,
    bold: true
  })), image.length > 1 && /*#__PURE__*/_react.default.createElement(_reactSlick.default, _extends({}, settings, {
    className: classes.carousel
  }), /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    className: "MuiCardMedia-product",
    image: image[0]
  }), /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    className: "MuiCardMedia-product",
    image: image[1]
  }), /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    className: "MuiCardMedia-product",
    image: image[2]
  })), image.length === 1 && /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    className: "MuiCardMedia-product",
    image: image[0]
  }), /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: desc
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    component: "h3",
    variant: "h4",
    title: title
  })), priceType === 'gl' && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: "From "
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: price,
    bold: true
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: " Upfront "
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: (price / 12).toFixed(2),
    bold: true
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: " /month"
  })), priceType === 'de' && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: "From "
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: price,
    bold: true
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: '€',
    bold: true
  })), priceType === 'uk' && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: "From ",
    dense: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: price,
    dense: true,
    bold: true
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: "\u20AC",
    dense: true,
    bold: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: " Upfront ",
    dense: true
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: "\xA0",
    dense: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: (price / 12).toFixed(2),
    dense: true,
    bold: true
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: "\u20AC",
    dense: true,
    bold: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: " /month",
    dense: true
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: "On a "
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: '36 Month',
    bold: true
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: " contract with "
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: 'Unlimited',
    bold: true
  }), /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body2",
    text: " data "
  })))), colors.length && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, colors.map(function (color, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: "auto",
      key: color
    }, /*#__PURE__*/_react.default.createElement(_PickerColor.default, {
      action: function action() {
        return setSelectedColor(index);
      },
      color: color,
      selected: index === selectedColor
    }));
  }))), sizes.length && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, sizes.map(function (size, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: "auto",
      key: size
    }, /*#__PURE__*/_react.default.createElement(_PickerSize.default, {
      action: function action() {
        return setSelectedSize(index);
      },
      text: size,
      selected: index === selectedSize
    }));
  }))), rating && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Rating.default, {
    name: "hover-feedback",
    value: value,
    onChange: function onChange(event, newValue) {
      setValue(newValue);
    },
    onChangeActive: function onChangeActive(event, newHover) {
      setHover(newHover);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, value !== null && /*#__PURE__*/_react.default.createElement(_Span.default, {
    variant: "body1",
    text: labels[hover !== -1 ? hover : value]
  })))))), compare && /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: (0, _classnames.default)({
      "MuiCardContent-footer": true
    })
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      onChange: function onChange() {
        return setChecked(!checked);
      },
      checked: checked,
      name: "compare",
      color: "primary"
    }),
    label: "Compare"
  }))));
};

CardProduct.propTypes = {
  title: _propTypes.default.string.isRequired,
  loading: _propTypes.default.bool
};
CardProduct.defaultProps = {
  loading: false
};
var _default = CardProduct;
exports.default = _default;